import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const DefaultPage = WithErrorBoundary(
  'Precio Justo',
  'Error en Precio Justo',
  React.lazy(() => import('./DefaultPage')),
)

const Dictionary = WithErrorBoundary(
  'Precio Justo',
  'Error en Precio Justo',
  React.lazy(() => import('./Dictionary')),
)

const DictionaryCrud = WithErrorBoundary(
  'Precio Justo',
  'Error en Precio Justo',
  React.lazy(() => import('./DictionaryCrud')),
)

const Search = WithErrorBoundary(
  'Precio Justo',
  'Error en Precio Justo',
  React.lazy(() => import('./Search')),
)

const MassiveProccessing = WithErrorBoundary(
  'Precio Justo',
  'Error en Precio Justo',
  React.lazy(() => import('./MassiveProccessing')),
)

export default {
  path: 'precio-justo',
  name: 'Precio justo',
  childRoutes: [
    { path: '', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'dictionaries', name: 'Dictionary', component: Dictionary },
    { path: 'dictionary', name: 'Dictionary crud', component: DictionaryCrud },
    { path: 'search', name: 'Search', component: Search },
    { path: 'batch', name: 'Massive proccessing', component: MassiveProccessing },
  ],
}
